import { makeStyles } from "@material-ui/core";

export const useFullWidthButtonStyles = makeStyles(() => ({
    button: {
        position: "absolute",
        bottom: 0,
        width: 530,
        marginBottom: 30
    }
}));
